import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider, AuthProviderProps } from 'oidc-react';

const oidcConfig: AuthProviderProps = {
  authority: "https://auth.lahjai.net",
  clientId: "b784cf14e28fe8fc1c6fbac28f8d6b91",

  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin + "/",

  responseType: "code",
  scope: "openid roles profile email lahja_api_app salla_api_app",

  autoSignIn: false,
  loadUserInfo: true,

  // ✅ مهم جداً
  automaticSilentRenew: true,
  silentRedirectUri: window.location.origin + "/silent-renew.html",

  onSignIn: async () => {
    const newUrl = window.location.origin;
    window.history.replaceState({}, document.title, newUrl);
  }
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider {...oidcConfig}>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);